!function($) {

  // OpenClaw: prevent variant swatch showing as hero image on initial page load.
  // We wrap Station.Theme.Media.Product.update and skip the first auto-call.
  // Subsequent user-triggered calls work normally.
  $(function() {
    var _ocInitDone = false;
    var _ocReady = false;

    // Wait for Station to be available, then wrap
    var _ocInterval = setInterval(function() {
      if (typeof Station !== 'undefined' &&
          Station.Theme &&
          Station.Theme.Media &&
          Station.Theme.Media.Product &&
          typeof Station.Theme.Media.Product.update === 'function') {

        clearInterval(_ocInterval);
        var _originalUpdate = Station.Theme.Media.Product.update;

        Station.Theme.Media.Product.update = function(variantId, container) {
          if (!_ocInitDone) {
            // Skip the first automatic call (page load variant init)
            _ocInitDone = true;
            return;
          }
          return _originalUpdate.apply(this, arguments);
        };

        // After 800ms, mark as ready — any calls after this are user-triggered
        setTimeout(function() {
          _ocReady = true;
          // Re-patch to always pass through after init window
          Station.Theme.Media.Product.update = function(variantId, container) {
            return _originalUpdate.apply(this, arguments);
          };
        }, 800);
      }
    }, 50);
  });

}(jQuery);